import React from 'react';
import PropTypes from 'prop-types';
import UppyUploader from '@components/common/uppy/main';
import { formattedUppyAttachment } from '@helpers/uppy';

class VideoWatermarkUppy extends React.Component {
  handleUpload = (files) => {
    if (!files.length) { return; }
    const file = formattedUppyAttachment(files[0]);
    this.props.onUpload(file)
  }

  uploadType = () => this.props.uploadType.toLowerCase();

  trigger = () => `uppy-trigger-${this.uploadType()}`;

  renderArea = () => (
    <div id={this.trigger()} className="uppy-video-watermark">
      <p>{t("Click to upload watermark")}</p>
    </div>
  );

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyUploader
          {...this.props}
          template={this.uploadType()}
          handleUpload={this.handleUpload}
          uniqIdentifier={`uppy-${this.uploadType()}`}
          restrictions={{ maxNumberOfFiles: 1, allowedFileTypes: ['.jpg', '.jpeg', '.png', '.bmp', '.gif'] }}
          locale={{ strings: { dropPaste: "Drag a file here or %{browse}", browse: "click to browse"} }}
          button
          trigger={`#${this.trigger()}`}
        />
      </React.Fragment>
    );
  }
}

VideoWatermarkUppy.propTypes = {
  uploadType: PropTypes.string.isRequired
};

export default VideoWatermarkUppy;
